import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('lastSynced');

    return {
        JUST_NOW: t('justNow'),
        LAST_SYNCED: ({ date }: { date: string }) => t('lastSynced', { date }),
        RELATIVE_DAYS: ({ count }: { count: number }) => t('relativeDays', { count }),
        RELATIVE_HOURS: ({ count }: { count: number }) => t('relativeHours', { count }),
        RELATIVE_MINUTES: ({ count }: { count: number }) => t('relativeMinutes', { count }),
        SYNCED: t('synced')
    };
};

export default useTranslation;
